.downloadHero {
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: end;
	min-height: calc(100svh - 4.5rem);
	padding-block-end: 1rem;
	position: relative;
	text-align: center;
	color: #fff;

	@media (min-width: 32rem) {
		height: calc(100svh - 16rem);
		min-height: 48rem;
	}
	@media (min-width: 80rem) {
		padding-block-end: 2rem;
	}

	.heroImgWrapper {
		flex: 1;
		min-height: 14rem;
		pointer-events: none;
		position: relative;
		width: 100%;
		z-index: 1;

		@media (min-width: 32rem) {
			margin-block-end: -12rem;
			mask-image: linear-gradient(180deg, transparent 0%, black 0%, black 35%, transparent 100%);
			min-height: 32rem;
		}

		.heroImg {
			display: block;
			height: 100%;
			inset: 0;
			max-width: 100%;
			object-fit: cover;
			position: absolute;
			width: 100%;
		}
	}

	.grid {
		align-items: center;
		display: flex;
		flex-direction: column;
		gap: 1rem;
		margin-inline: auto;
		max-width: 100rem;
		@media (min-width: 32rem) {
			align-items: stretch;
			width: 100%;
		}
		@media (min-width: 80rem) {
			flex-direction: row;
			gap: 2rem;
			padding-inline: 2rem;
		}

		.heroContentWrapper {
			flex-shrink: 0;
			overflow: visible;
			margin-inline: auto;
			max-width: 78rem;
			min-width: 24rem;
			position: relative;
			width: 100%;
			z-index: 2;
			@media (min-width: 32rem) and (max-width: calc(64rem - 1px)) {
				min-width: 24rem;
				padding-inline: 1rem;
				max-width: fit-content;
			}
			@media (min-width: 80rem) {
				width: auto;
				min-width: 0;
				flex-basis: 60%;
			}
			@media (min-width: 64rem) and (max-width: calc(80rem - 1px)) {
				margin-inline: 1rem;
			}

			.heroBackplate {
				margin-inline: auto;
				overflow: visible;
				padding: 1.5rem;
				position: relative;
				width: 100%;
				z-index: 1;
				@media (min-width: 32rem) {
					border-radius: 1.25rem;
				}

				.heroContent {
					align-items: center;
					column-gap: 2rem;
					display: flex;
					flex-direction: column;
					flex-wrap: nowrap;
					row-gap: 1.5rem;
					position: relative;
					z-index: 1;
					@media (min-width: 64rem) {
						align-items: stretch;
						flex-direction: row;
						gap: 2rem;
						text-align: start;
					}

					.appIcon {
						align-self: center;
						border-radius: 1.25rem;
						flex-shrink: 0;
						height: 5rem;
						overflow: hidden;
						width: 5rem;
						@media (max-width: calc(64rem - 1px)) {
							margin-block-end: -4rem;
							transform: translateY(-4rem);
						}
					}

					.titleWrapper {
						display: flex;
						flex-direction: column;
						flex-grow: 1;
						flex-shrink: 1;
						gap: 0.75rem;
						justify-content: center;
					}

					.buttonWrapper {
						display: flex;
						flex-direction: column;
						flex-shrink: 0;
						gap: 0.75rem;
						justify-content: center;
						justify-self: end;
						@media (max-width: calc(64rem - 1px)) {
							width: 100%;
						}
						@media (min-width: 80rem) {
							justify-content: stretch;
							min-width: 0;
						}

						.modalBtn {
							display: flex;
							align-items: center;
							justify-content: center;
							gap: 0.5rem;
							width: 100%;
							background-color: #6a6d70;
							color: #ffffff;
							font-family: BourgeoisUltra, "Arial Regular", Arial, sans-serif;
							font-weight: 700;
							font-size: 1.125rem;
							text-transform: uppercase;
							line-height: 1.375rem;
							padding: 11.5px 1rem;
							border-radius: 11px;
							border: none;
							cursor: pointer;

							&:hover {
								background-color: #7e7f81;
							}

							span {
								line-height: 1;
								margin-bottom: -5px;
							}

							img {
								filter: brightness(0) invert(1);
							}
						}
					}
				}
			}
		}

		.qrCodeWrapper {
			border-radius: 1.25rem;
			padding: 1rem;
			position: relative;
			text-align: start;
			z-index: 1;
			@media (max-width: calc(80rem - 1px)) {
				margin-inline: 1rem;
			}
			@media (min-width: 80rem) {
				flex-basis: 40%;
				min-width: 1;
				padding: 1.5rem;
			}

			.qrCodeContent {
				align-items: center;
				justify-content: start;
				display: flex;
				gap: 1rem;
				position: relative;
				z-index: 1;
				height: 100%;

				.qrCode {
					border-radius: 1.25rem;
					height: 5.5rem;
					width: 5.5rem;
					@media (min-width: 80rem) {
						height: 7rem;
						width: 7rem;
					}
				}
			}
		}
	}
}

.backplate {
	backdrop-filter: blur(8rem);
	background-color: rgba(0, 0, 0, 0.45);
	border-radius: inherit;
	inset: 0;
	position: absolute;
}

.sectionTitle {
	font-family: BourgeoisUltra, "Arial Regular", Arial, sans-serif;
	font-size: 32px;
	text-transform: uppercase;
	line-height: 1;
}

.sectionCopy {
	font-family: "Bourgeois W00 Medium", sans-serif;
	font-size: 16px;
}
